import memoize from "fast-memoize";
export class Adapter {
    constructor(items, keys, hash) {
        this.name = "BaseAdapter";
        this.items = [];
        this.keys = [];
        this.options = {};
        this.hash = 0;
        this.perf = {
            time: 0,
            count: 0
        };
        this.scorer = this.initScorer();
        this.cachedSearch = memoize((query, hash) => {
            const start = performance.now();
            const matchingItems = this.scorer.search(query);
            const end = performance.now();
            // track every query to get an average time per scorer.  we do this
            // inside the memoized search function so that the time and counts
            // only update when there's a new search.
            this.perf.time += end - start;
            this.perf.count++;
            return this.convertResults(matchingItems);
        });
        this.items = items;
        this.keys = keys;
        this.hash = hash;
        this.options = Object.assign(Object.assign({}, this.defaultOptions), { keys });
        this.initScorer();
    }
    get defaultOptions() {
        return {};
    }
    get averageTime() {
        return Number((this.perf.time / this.perf.count).toFixed(1));
    }
    initScorer() {
        return this.scorer = { search: () => ([]) };
    }
    update(items, hash) {
        this.items = items;
        this.hash = hash;
        this.initScorer();
    }
    convertResults(results) {
        return results;
    }
    search(query) {
        return this.cachedSearch(query, this.hash);
    }
}
